export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_hygiene-spaces/artifacts/jm4jhbtf_WhatsApp%20Image%202026-04-21%20at%2016.38.34.jpeg";

export const BUSINESS = {
  name: "Néma Services",
  phone: "06 26 09 74 90",
  phoneRaw: "0626097490",
  email: "contact@nema-services.fr",
  zone: "Toute l'Île-de-France",
};

export const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Secteurs", href: "#secteurs" },
  { label: "Processus", href: "#process" },
  { label: "Avis", href: "#temoignages" },
  { label: "FAQ", href: "#faq" },
  { label: "Devis", href: "#devis" },
];
